export class PeriodoInventarioCerrado {
  constructor(periodo) {
    this.eventName = "PeriodoInventarioCerrado";
    this.ocurrio = new Date();
    this.data = periodo;
  }
}